import { Injectable } from '@angular/core';
import { AjaxResponse } from 'rxjs/ajax';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseRequester } from './common/base-requester';

@Injectable({
    providedIn: 'root',
})
export class UnifiedQueryV2Service extends BaseRequester {
    constructor() {
        super();
    }
    query<T>(request: UnifiedQueryRequestV2): Observable<T[]> {
        return this.post<UnifiedQueryRequestV2, T>(request);
    }

    // Server-side aggregation (read-only: the lambda rejects $out/$merge).
    // Use when the answer is a reduction (group/avg/count) — shipping the raw
    // rows through query() and reducing in the browser doesn't scale.
    aggregate<T>(request: UnifiedAggregateRequestV2): Observable<T[]> {
        return this.post<UnifiedAggregateRequestV2, T>(request);
    }

    private post<R, T>(request: R): Observable<T[]> {
        return this.internalPostRequest<R>(
            environment.unifiedQueryV2EndPoint,
            request,
        ).pipe(
            map((response: AjaxResponse) => {
                if (response.response.errorMessage) {
                    throw new Error(
                        `[${response.response.errorType}]: ${response.response.errorMessage}`,
                    );
                } else {
                    return response.response;
                }
            }),
        );
    }
}

export interface UnifiedQueryRequestV2 {
    db: string;
    col: string;
    query: object;
    options?: object;
}

export interface UnifiedAggregateRequestV2 {
    db: string;
    col: string;
    pipeline: object[];
    options?: object;
}
